"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

!function (t, e) {
  for (var n in e) {
    t[n] = e[n];
  }
}(exports, function (t) {
  var e = {};function n(i) {
    if (e[i]) return e[i].exports;var s = e[i] = { i: i, l: !1, exports: {} };return t[i].call(s.exports, s, s.exports, n), s.l = !0, s.exports;
  }return n.m = t, n.c = e, n.d = function (t, e, i) {
    n.o(t, e) || Object.defineProperty(t, e, { enumerable: !0, get: i });
  }, n.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(t, "__esModule", { value: !0 });
  }, n.t = function (t, e) {
    if (1 & e && (t = n(t)), 8 & e) return t;if (4 & e && "object" == (typeof t === "undefined" ? "undefined" : _typeof(t)) && t && t.__esModule) return t;var i = Object.create(null);if (n.r(i), Object.defineProperty(i, "default", { enumerable: !0, value: t }), 2 & e && "string" != typeof t) for (var s in t) {
      n.d(i, s, function (e) {
        return t[e];
      }.bind(null, s));
    }return i;
  }, n.n = function (t) {
    var e = t && t.__esModule ? function () {
      return t.default;
    } : function () {
      return t;
    };return n.d(e, "a", e), e;
  }, n.o = function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }, n.p = "", n(n.s = 94);
}({ 0: function _(t, e) {
    t.exports = function () {
      function _class() {
        _classCallCheck(this, _class);
      }

      _createClass(_class, null, [{
        key: "triggerEvent",
        value: function triggerEvent(t, e) {
          var n = void 0;"function" == typeof Event ? n = new Event(e) : (n = document.createEvent("Event"), n.initEvent(e, !0, !0)), t.dispatchEvent(n);
        }
      }, {
        key: "getElementByAttribute",
        value: function getElementByAttribute(t, e) {
          return e ? document.querySelector("[" + t + "=\"" + e + "\"]") : document.querySelector("[" + t + "]");
        }
      }, {
        key: "getElementsByAttribute",
        value: function getElementsByAttribute(t, e) {
          return e ? document.querySelectorAll("[" + t + "=\"" + e + "\"]") : document.querySelectorAll("[" + t + "]");
        }
      }, {
        key: "getElementByAttributeWithinElement",
        value: function getElementByAttributeWithinElement(t, e, n) {
          return n ? t.querySelector("[" + e + "=\"" + n + "\"]") : t.querySelector("[" + e + "]");
        }
      }, {
        key: "isMouseOver",
        value: function isMouseOver(t) {
          return Array.prototype.slice.call(t.parentElement.querySelectorAll(":hover")).filter(function () {
            return t[0] == this;
          }).length > 0;
        }
      }, {
        key: "getElementsByAttributeWithinElement",
        value: function getElementsByAttributeWithinElement(t, e, n) {
          return n ? t.querySelectorAll("[" + e + "=\"" + n + "\"]") : t.querySelectorAll("[" + e + "]");
        }
      }, {
        key: "getElementByClassWithinElement",
        value: function getElementByClassWithinElement(t, e) {
          return t.querySelector("." + e);
        }
      }, {
        key: "maxWidthMobileViewports",
        value: function maxWidthMobileViewports() {
          return 940;
        }
      }, {
        key: "createEvent",
        value: function createEvent(t) {
          var e = void 0;return "function" == typeof Event ? e = new Event(t) : (e = document.createEvent("Event"), e.initEvent(t, !0, !0)), e;
        }
      }, {
        key: "isDesktop",
        value: function isDesktop() {
          return Math.max(document.documentElement.clientWidth, window.innerWidth || 0) > this.maxWidthMobileViewports();
        }
      }, {
        key: "isIE11",
        value: function isIE11() {
          return -1 !== navigator.userAgent.indexOf("MSIE") || navigator.appVersion.indexOf("Trident/") > -1;
        }
      }, {
        key: "getKeyCodeOnKeyDownEvent",
        value: function getKeyCodeOnKeyDownEvent(t) {
          var e = void 0;if (null != t) if (void 0 === t.code) switch (t.keyCode) {case 13:
              e = "Enter";break;case 38:
              e = "ArrowUp";break;case 40:
              e = "ArrowDown";break;case 8:
              e = "Backspace";break;case 9:
              e = "Tab";break;case 27:
              e = "Escape";break;case 33:
              e = "PageUp";break;case 34:
              e = "PageDown";break;case 32:
              e = "Space";break;default:
              e = void 0;} else e = t.code;return e;
        }
      }, {
        key: "getKeyboardFocusableElements",
        value: function getKeyboardFocusableElements(t) {
          return [].concat(_toConsumableArray(t.querySelectorAll('a[href], button, input, textarea, iframe, select, details,[tabindex]:not([tabindex="-1"])'))).filter(function (t) {
            return !function (t) {
              return "hidden" === window.getComputedStyle(t).visibility;
            }(t) && !t.hasAttribute("disabled") && !t.getAttribute("aria-hidden");
          });
        }
      }]);

      return _class;
    }();
  }, 94: function _(t, e, n) {
    t.exports = n(95);
  }, 95: function _(t, e, n) {
    "use strict";
    n.r(e), n.d(e, "Collapsible", function () {
      return l;
    });var i = n(0),
        s = n.n(i);var r = "data-rs-collapsible";
    var l = function () {
      function l(t) {
        _classCallCheck(this, l);

        this.element = t, this.content = this.element.parentElement.querySelector("[" + this.attributes.content + "]"), this.triggerElement = this.element, this.initialExpanded = this.content.getAttribute(this.attributes.content) === this.states.expanded, this.elementsToClose = s.a.getElementsByAttribute(this.attributes.closeOnScroll), this.addEventHandlers();
      }

      _createClass(l, [{
        key: "addEventHandlers",
        value: function addEventHandlers() {
          var _this = this;

          var t = this.content.offsetHeight,
              e = window.innerWidth;this.element.getAttribute(r) === this.attributes.navigation && (this.triggerElement = this.element.querySelector("[" + this.attributes.button + "]")), null != this.triggerElement && ["click", "keydown"].forEach(function (e) {
            _this.triggerElement.addEventListener(e, function (e) {
              ("keydown" !== e.type || 13 !== e.keyCode && 32 !== e.keyCode) && "click" !== e.type || (e.preventDefault(), _this.toggle(t));
            });
          }), this.isInitiallyExpanded(t), this.isOverflown(this.content, this.element), window.addEventListener("orientationchange", function () {
            _this.recalculateContentHeight(), _this.isOverflown(_this.content, _this.element);
          }), window.addEventListener("resize", function () {
            window.innerWidth !== e && (_this.recalculateContentHeight(), _this.isOverflown(_this.content, _this.element));
          }), this.elementsToClose && window.addEventListener("scroll", function () {
            _this.simulateClickOnScroll();
          });
        }
      }, {
        key: "setInitialValues",
        value: function setInitialValues() {}
      }, {
        key: "isExpandedElementToClose",
        value: function isExpandedElementToClose() {
          var _this2 = this;

          if (!this.elementsToClose) return;var t = [];return this.elementsToClose.forEach(function (e) {
            e.classList.contains(_this2.classes.collapsibleTriggerExpanded) && e.hasAttribute(_this2.attributes.closeOnScroll) && t.push(e);
          }), t;
        }
      }, {
        key: "simulateClickOnScroll",
        value: function simulateClickOnScroll() {
          var t = this.isExpandedElementToClose(),
              e = window.scrollY;t.forEach(function (t) {
            var n = t.parentElement.offsetTop;e > n && t.click();
          });
        }
      }, {
        key: "toggle",
        value: function toggle(t) {
          var e = this.initialExpanded ? "0" : t;if (this.isTriggerExpanded) this.collapseTrigger(), this.collapseContent(e);else {
            var _t = this.content.scrollHeight;this.expandTrigger(), this.expandContent(_t);
          }
        }
      }, {
        key: "collapseTrigger",
        value: function collapseTrigger() {
          this.element.classList.remove(this.classes.collapsibleTriggerExpanded), this.element.setAttribute(this.attributes.ariaExpanded, "false");
        }
      }, {
        key: "collapseContent",
        value: function collapseContent(t) {
          this.content.style.maxHeight = t + "px", this.content.setAttribute(this.attributes.content, ""), this.content.setAttribute(this.attributes.ariaExpanded, "false");
        }
      }, {
        key: "expandTrigger",
        value: function expandTrigger() {
          this.element.classList.add(this.classes.collapsibleTriggerExpanded), this.element.setAttribute(this.attributes.ariaExpanded, "true");
        }
      }, {
        key: "expandContent",
        value: function expandContent(t) {
          this.content.style.maxHeight = t + 30 + "px", this.content.setAttribute(this.attributes.content, this.states.expanded), this.content.setAttribute(this.attributes.ariaExpanded, "true");
        }
      }, {
        key: "isInitiallyExpanded",
        value: function isInitiallyExpanded() {
          this.initialExpanded && this.expandTrigger();
        }
      }, {
        key: "recalculateContentHeight",
        value: function recalculateContentHeight() {
          this.content = this.element.parentElement.querySelector("[" + this.attributes.content + "]"), this.contentHeight = this.content.scrollHeight, this.content.getAttribute(this.attributes.content) === this.states.expanded && (this.content.style.maxHeight = this.contentHeight + "px");
        }
      }, {
        key: "isOverflown",
        value: function isOverflown(t, e) {
          if ("hide-trigger" === e.getAttribute(r)) {
            var _n = t.scrollHeight > t.clientHeight || t.scrollWidth > t.clientWidth;_n || e.classList.add("display-none"), _n && e.classList.remove("display-none");
          }
        }
      }, {
        key: "attributes",
        get: function get() {
          return { content: r + "-content", button: r + "-button", navigation: "navigation", ariaExpanded: "aria-expanded", filter: "filter", closeOnOutsideClick: r + "-close-on-outside-click", closeOnScroll: r + "-close-on-scroll" };
        }
      }, {
        key: "classes",
        get: function get() {
          return { collapsibleTriggerExpanded: "collapsible__trigger--expanded" };
        }
      }, {
        key: "states",
        get: function get() {
          return { expanded: "expanded" };
        }
      }, {
        key: "isTriggerExpanded",
        get: function get() {
          return this.element.classList.contains(this.classes.collapsibleTriggerExpanded);
        }
      }], [{
        key: "getSelector",
        value: function getSelector() {
          return "[" + r + "]";
        }
      }]);

      return l;
    }();
  } }));